import $ from "jquery";

var GPPYChangeAvatar = {
    init: function() {
        $('.changeAvatar .selectFileLink').click(function() {
            $('.changeAvatar input').click();
        })

        $('.changeAvatar input').change(GPPYChangeAvatar.upload);
    },

    upload: function(event) {
        var files = event.target.files;
        var data = new FormData();
        $.each(files, function(key, value)
        {
            data.append(key, value);
        });
        Promise.resolve($.ajax({
            url : '/api/changeAvatar',
            type: 'POST',
            data: data,
            dataType: 'json',
            processData: false,
            contentType: false
        })).then(GPPYChangeAvatar.uploaded)
    },

    uploaded: function(res) {
        $('.avatars img').attr("src", res.avatarFile);
    }
}

$('document').ready(GPPYChangeAvatar.init);

